<template>
  <div class="biasfx2">
    <Banner :with-bias-banner="true" />
    <div style="position: relative;">
      <BiasMiniGuitarBanner />
    </div>
    <div style="margin-top: 86px;">
      <BiasMiniGuitarSpecCarousel />
    </div>
    <section class="spec-hero">
      <div>
        <div class="text text-left">
          <ul>
            <li>具备元件级模拟引擎的吉他放大器</li>
            <li>16个板载的音箱模拟预设（在音色云上更有数以千计的音箱预设）</li>
            <li>内置300瓦D类功率放大器（300 瓦 @4 ohms, 150 瓦 @8 ohms）</li>
            <li>内置蓝牙功能，支持iPhone/iPad无线遙控</li>
            <li>提供1/8英寸接口的MIDI 输入/输出（包含适配线）</li>
            <li>1/4英寸扬声器输出和平衡XLR线路输出</li>
            <li>前面板提供1/4英寸耳机输出接口</li>
            <li>开关踏板输入用于连接专门的预设切换踏板 BFS-4 （单独另售）</li>
          </ul>
        </div>
        <div class="text text-right">
          <ul>
            <li>USB接口可连接 MAC 或 WINDOWS 电脑</li>
            <li>贈送 BIAS AMP 2 Pro 及 BIAS AMP 2 iPhone/iPad软件专业版（价值 $199美金）</li>
            <li>音色云集成 – 在云端下载和分享音箱预设</li>
            <li>内置噪声门及9种混响</li>
            <li>支持Amp Match® （音箱匹配）定制音箱及定制 IR</li>
            <li>尺寸（宽x高x深）: 26.3 x 4.5 x 24.3 厘米 (10.35 x 1.77 x 9.56 英寸)</li>
            <li>外形紧凑，重量仅2.36公斤</li>
          </ul>
        </div>
      </div>
    </section>
    <div class="clear" />
    <footer-weixin />
    <footer-common />
  </div>
</template>

<script>
import BiasMiniGuitarBanner from '@/components/bias-mini-guitar-banner'
import BiasMiniGuitarSpecCarousel from '@/components/bias-mini-guitar-spec-carousel'
import Banner from '@/components/banner'
import FooterWeixin from '@/components/footer-weixin'
import FooterCommon from '@/components/footer-common'

import store from '@/store'

export default {
  name: 'Index',
  store,
  components: {
    Banner, FooterWeixin, FooterCommon, BiasMiniGuitarBanner, BiasMiniGuitarSpecCarousel
  },
  data () {
    return {}
  },
  computed: {},
  mounted: function () { },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import "../styles/pages/bias-fx2.scss";
@import "../styles/pages/bias-mini-guitar.scss";
</style>



// WEBPACK FOOTER //
// src/pages/bias-mini-guitar-spec.vue